// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"9b6230b0","284":"5184a5c8","333":"4075bc87","386":"c8dbb1e3","453":"19614b46","760":"87775963","909":"b63dad3a","988":"7614e2c1"}[chunkId] + ".chunk.js";
};